// Antfarma theme — shared interactions

document.addEventListener('DOMContentLoaded', function () {

  // FAQ accordions (homepage + product page use the same pattern)
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-accordion-item]');
      var group = item.parentElement;
      var wasOpen = item.classList.contains('open');
      if (group.hasAttribute('data-accordion-single')) {
        group.querySelectorAll('[data-accordion-item]').forEach(function (i) {
          i.classList.remove('open');
        });
      }
      if (!wasOpen) item.classList.add('open');
      else item.classList.remove('open');
    });
  });

  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // Product gallery thumbnail swap
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      thumb.closest('[data-gallery-thumbs]').querySelectorAll('img').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // Quantity steppers (product page + cart page)
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Cart line quantity change -> submit via /cart/change.js so the page updates without a full reload
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.line;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10) || 1 })
      }).then(function () { window.location.reload(); });
    });
  });

});
